import React, { createContext, useContext, useEffect, useState } from "react";
import { useRpc } from "./RpcContext";

export type TDialogsIdEnum =
  | "create-dialog"
  | "find-dialog"
  | "diagnostic-dialog"
  | "create-choice-list"
  | "massKDLConsumption"
  | "power_profile"
  | "counter_data"
  | "relogin"
  | "command-parameter";

// Контекст
interface ModalContextType {
  showModal: boolean;
  modalData: any;
  openModal: (rowData: any, modalId: TDialogsIdEnum) => void;
  modalId: TDialogsIdEnum | null;
  closeModal: () => void;
  setModalData: React.Dispatch<React.SetStateAction<any>>;
}

// Создание контекста
const ModalContext = createContext<ModalContextType | undefined>(undefined);

// Провайдер контекста
export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState<any>(null);
  const [modalId, setModalId] = useState<TDialogsIdEnum | null>(null);

  const { wsOpened } = useRpc();

  useEffect(() => {
    if (!wsOpened) {
      setShowModal(false);
      setModalData(null);
      setModalId(null);
    }
  }, [wsOpened]);

  const openModal = (rowData: any, modalId: TDialogsIdEnum) => {
    setModalData(rowData);
    setShowModal(true);
    setModalId(modalId);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalData(null);
  };

  return (
    <ModalContext.Provider
      value={{
        showModal,
        modalData,
        openModal,
        closeModal,
        setModalData,
        modalId,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

// Хук для использования контекста
export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModalContext must be used within a ModalProvider");
  }
  return context;
};
